<template>
  <div class="home contenido">
    <div class="container">
        <HelloWorld 
            msg="Asesoría en siniestros"
            idea="Los siniestros son situaciones que nadie espera vivir, de ahí la importancia de contar con el soporte adecuado que te ayuda a prevenirlos y una vez sucedidos, te ayude a continuar con el menor daño posible."
            :imagen="imagen"
         />
         <Titulo titulo="¿Cómo lo hacemos?" />
         <div class="espacio mt-5"></div>
         <Fototextosombra titulo="Recuperarse para seguir adelante" texto="Definitivamente los siniestros son el tipo de eventualidades que muestran la personalidad de cada uno, su forma de reaccionar y para nuestra actividad es la prueba de fuego: <i>demuestran el compromiso y exhiben si estamos o no a la altura de lo esperado</i>." :imagen="imagen2" pos="fotoderecha" />
         <Fototextosombra texto="<p>La asesoría en siniestros pone atención en tres aspectos esenciales:</p><ul>
         <li class='mb-3'><strong>Adelántate.</strong> Frente a un siniestro es vital para toda organización, el tiempo de recuperación ante las pérdidas; un factor que hace la diferencia para seguir adelante.</li>
         <li class='mb-3'><strong>Observa.</strong>Considera tres aspectos importantes: la prevención, la respuesta y recuperación y finalmente la más importante, el aprendizaje.</li>
         <li class='mb-3'><strong>Profundiza.</strong>Nuestro método de trabajo te apoya revisando tanto aspectos de contratos, como estrategias de comunicación, hasta litigios de recuperación cuando es requerido.</li>
         </ul>" :imagen="imagen3" pos="fotoizquierda" />
         <Fototextosombra texto="<strong>En RMZ Asesores,</strong> aplicamos nuestra experiencia, capacidad y compromiso para marcar la diferencia y asegurar la continuidad de tu empresa ante cualquier circunstancia." :imagen="imagen4" pos="fotoderecha" />
         <Titulo2 titulo="¿Estás preparado para enfrentar un siniestro?" />
    </div>
    <div class="triangulo"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Imagen from '@/assets/images/banner-header-new_04-asesoria-en-siniestros.jpg'
import Imagen2 from '@/assets/images/pageinteriors_04asesoria-en-siniestros-01.jpg'
import Imagen3 from '@/assets/images/pageinteriors_04asesoria-en-siniestros-02.jpg'
import Imagen4 from '@/assets/images/pageinteriors_04asesoria-en-siniestros-03.jpg'
import Titulo from '@/components/Titulo.vue'
import Titulo2 from '@/components/Titulo2.vue'
import Fototextosombra from '@/components/Fototextosombra.vue'
export default {
  name: 'Nosotros',
  data() {
      return {
          imagen: Imagen,
          imagen2: Imagen2,
          imagen3: Imagen3,
          imagen4: Imagen4,
      }
  },
  components: {
    HelloWorld,
    Titulo,
    Titulo2,
    Fototextosombra,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      muestraFooter: function(){
          this.$store.commit('muestraFooter');
      }
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.muestraFooter();
      this.$store.commit('mideMenos', false);
      this.$store.commit('mideMas', false);
      this.$store.commit('estira', true);
  }
}
</script>
<style>
.container-fluid {
    /*background-size: cover;
    background: url(../assets/images/background-pattern01-short.png);*/
}
.rojo {
    color: red;
}
</style>
<style scoped>
.blanco {
    background: #FFF;
}
.contenido {
    min-height: 500px;
}
.gris {
    background: #F2F2F2;
    border-bottom: 8px solid #000;
    margin-top: 180px !important;
}
.triangulo {
    width: 100%;
    height: 100px;
    clip-path: polygon(50% 50px, 0% 0%, 100% 0%);
    background: #FFF;
    margin-top: 0;
    position: absolute;
    z-index: 100;
}
h3 {
    font-size: 26px;
    font-weight: 700;
}
.texto {

}
.crm-titulo {
    font-weight: 700;
    font-size: 14px;
}
.crm-subtitulo {
    font-weight: 700;
    font-size: 18px;
}
.img-crm {
    width: 125px;
}
@media only screen and (max-width: 1199px){
    .crm-titulo {
        font-weight: 700;
        font-size: 14px;
    }
    .crm-subtitulo {
        font-weight: 700;
        font-size: 17px;
    }
    .img-crm {
    }
    .triangulo {
        height: 50px;
    }
}
</style>
